import { Navigate } from 'react-router-dom';

import './pin-code-page.scss';

import { useIsCustomer } from '~modules/auth/model';
import { routerKeys } from '~shared/router';
import { Preloader } from '~shared/ui';

import { usePinCodes } from './use-pin-codes';

/** Пустое поле не оставляем незаполненным: сотруднику должно быть видно, что кода нет, а не что страница сломалась */
const EMPTY_VALUE = 'не назначен';

export function PinCodePage() {
	const isCustomer = useIsCustomer();
	const { pending, pinCodes, isError } = usePinCodes();

	if (!isCustomer) return <Navigate to={routerKeys.denied()} />;

	return (
		<div className="pin-code-page">
			<h1>Пин-коды</h1>
			<div className="pin-code-page__card">
				{pending && <Preloader />}
				{!pending && isError && <div>Не удалось загрузить пин-коды. Попробуйте обновить страницу.</div>}
				{!pending && !isError && (
					<>
						<div className="pin-code-page__row">
							<span className="pin-code-page__label">Текущий пин-код:</span>
							<span className="pin-code-page__value">{pinCodes?.current_pin_code || EMPTY_VALUE}</span>
						</div>
						<div className="pin-code-page__row">
							<span className="pin-code-page__label">Дата действия текущего пин-кода:</span>
							<span className="pin-code-page__value">
								{pinCodes?.current_pin_code_expiry_date || EMPTY_VALUE}
							</span>
						</div>
						<div className="pin-code-page__row">
							<span className="pin-code-page__label">Новый пин-код:</span>
							<span className="pin-code-page__value">{pinCodes?.next_pin_code || EMPTY_VALUE}</span>
						</div>
					</>
				)}
			</div>
		</div>
	);
}
